module.exports = __webpack_public_path__ + "img/driver-empty-img2.56806f81.png";